import React from 'react';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import user from '../../../redux/reducer/user';
import { useDispatch } from 'react-redux';

export default function WordForm({ slots, onSubmit }) {
  const dispatch = useDispatch();

  return (
    <form onSubmit={onSubmit} className={'word-modal__form'}>
      {slots?.inputs?.map?.(WrapCheck)}
      <CustomButton
        className={'custom-button word-modal__button word-modal__button_check word-modal_check'}
        text={'wordModalContent.check'}
      />
    </form>
  );

  function WrapCheck(item, index) {
    const { key } = item;
    const keyStr = `${key}-${index}`;
    if (typeof item.props.Wrapper === 'function') return item.props.Wrapper(item, item.props, keyStr);
    return item;
  }
}
